import { Injectable, ViewContainerRef } from '@angular/core';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { OidcSecurityService } from '../../auth/services/oidc.security.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ToastModel } from '../models/ToastModel';
import { ErrorModel } from '../models/ErrorModel';
declare var Materialize: any;

@Injectable()
export class NotificationHandlerService {

    private log_errors_active: boolean;
    private log_toast_debug_active: boolean;
    private log_console_debug_active: boolean;
    private uData: any;

    constructor(private _securityService: OidcSecurityService) {
        this._securityService.getUserData().subscribe(data => this.uData = data);
    }

    // Update properties to log or not to log
    public updateConsoleLog(status: boolean): void {
        this.log_console_debug_active = status;
    }

    public updateToastLog(status: boolean): void {
        this.log_toast_debug_active = status;
    }

    public updateErrorLog(status: boolean): void {
        this.log_errors_active = status;
    }

    // API response handling
    public handleError(data: any): void {
        let error: ErrorModel;
        try {
            error = JSON.parse(data._body);
            if (error.hasOwnProperty('IsError')) {
                this.logToastError(error.Msg);
                this.logConsoleError(error.Msg);
            }
        } catch (ex) {
            this.logConsoleError('Error parsing server error response...');
        }
    }

    public handleSuccess(msg: string): void {
        this.logConsoleSuccess(msg);
        this.logToastSuccess(msg);
    }

    // Console related logging functions
    public logConsoleError(msg: string): void {
        if (this.log_console_debug_active) {
            console.log('**ERROR**==>' + msg);
        }
    }

    public logConsoleWarning(msg: string): void {
        if (this.log_console_debug_active) {
            console.log('**WARNING**==>' + msg);
        }
    }

    public logConsoleSuccess(msg: string): void {
        if (this.log_console_debug_active) {
            console.log('**SUCCESS**==>' + msg);
        }
    }

    public logConsoleInfo(msg: any): void {
        if (this.log_console_debug_active) {
            console.log('**INFO**==>' + msg);
        }
    }

    // General notifications
    public logError(e: any) {
        this.logConsoleError((<Error>e).message);
        this.logToastError('Oops, something went wrong!');
    }

    // Toast related logging functions
    public logToastError(errorMsg: string, time = 3500): void {
        if (this.log_toast_debug_active) {
            Materialize.toast('<div class="custom-toast" style="width: 100%"><i class="material-icons left">error</i>' + errorMsg + '</div>', time, 'red');
        }
    }

    public logToastWarning(warningMsg: string, time = 3500): void {
        if (this.log_toast_debug_active) {
            Materialize.toast('<div class="custom-toast" style="width: 100%"><i class="material-icons left">warning</i>' + warningMsg + '</div>', time, 'orange');

        }
    }

    public logToastSuccess(successMsg: string, time = 3500): void {
        if (this.log_toast_debug_active) {
            Materialize.toast('<div class="custom-toast" style="width: 100%"><i class="material-icons left">check_circle</i>' + successMsg + '</div>', time, 'green');
        }
    }

    public logToastInfo(infoMsg: string, time = 3500): void {
        if (this.log_toast_debug_active) {
            Materialize.toast('<div class="custom-toast" style="width: 100%"><i class="material-icons left">help</i>' + infoMsg + '</div>', time);
        }
    }
}


// WEBPACK FOOTER //
// ./angularApp/app/shared/notifications/notification-handler.service.ts